<span matSnackBarActions class="snackbar-actions">
    <mat-icon id="snackbar-icon">{{data.icon}}</mat-icon>
    <h3>{{data.heading}}</h3>
    <span class="spacer"></span>
    <button mat-icon-button id="close-button" (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>
</span>

<span matSnackBarLabel>
    {{data.message}}
</span>

